module.exports = __webpack_public_path__ + "img/jszr.8d0ae14e.jpg";